module.exports = __webpack_public_path__ + "img/Buana Multidana.9d295f53.png";